module.exports = __webpack_public_path__ + "static/media/neutral-face.deace257.svg";